export const GOOGLE_MAPS_LOADER_ID = 'fleet-google-maps';
export const GOOGLE_MAPS_LOADER_LIBRARIES = ['geometry'];
export const getGoogleMapsApiKey = () => {
  if (typeof window !== 'undefined' && window.REACT_APP_GOOGLE_MAPS_KEY) {
    return window.REACT_APP_GOOGLE_MAPS_KEY;
  }
  return process.env.REACT_APP_GOOGLE_MAPS_KEY || process.env.REACT_APP_GOOGLE_MAPS_API_KEY || '';
};
